var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn large",attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v("Suchen")])])])}
var staticRenderFns = []

export { render, staticRenderFns }